import { calculateAmericanPrice } from '~shared/components/sport-event/utils';
import { ODDS_BOOST_LOCATIONS } from './constants';

/**
 * getOddsBoostSelection returns the was price for odds boost in the selection
 * @param {object} selection The selection
 * @returns {object} The selection with the was prices
 */
export const getOddsBoostSelection = (selection) => {
    if (selection.old_decimal_price) {
        return {
            ...selection,
            american_price: calculateAmericanPrice(selection.old_decimal_price),
            fraction_price: selection.old_fraction_price,
            decimal_price: selection.old_decimal_price,
        };
    }

    return null;
};

/**
 * @param {String} oddsBoostLocation Location of where oddsBoost is being used.
 * @param {String} categorySlug for odds boost, the categorySlug will be the sport slug of the sport it's related to.
 * @param {String} source for homepage variant, the source is different
 * @returns {String} gtm tag relevant to area.
 */
export const generateOddsBoostGtm = (oddsBoostLocation, categorySlug, source = 'homepage') => {
    switch (oddsBoostLocation) {
        case ODDS_BOOST_LOCATIONS.HOMEPAGE_WIDGET:
            return `${source};odds-boost-widget;`;
        case ODDS_BOOST_LOCATIONS.ODDS_BOOST_PAGE:
            // instruction cards will not have a sport slug
            return categorySlug
                ? `odds-boost-home;${categorySlug};`
                : 'odds-boost-home;';
        case ODDS_BOOST_LOCATIONS.SPORTS_PAGE:
        case ODDS_BOOST_LOCATIONS.RACING_PAGE:
            // instruction cards will not have a sport slug
            return categorySlug
                ? `${categorySlug};odds-boost-carousel;`
                : 'odds-boost-carousel;';
        default:
            return '';
    }
};
